// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";
import {KeyboardBackspace} from "@mui/icons-material";
import {createSearchParams, Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import OtpInput from 'react-otp-input';
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../../redux/loading/actions";
import {Box, CircularProgress} from "@mui/material";
import {useShowMessageComponent} from "../../assets/js/main";
import HandleFetchData from "../../plugin/HandleFetchData";


export default function VerifyCode() {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t, i18n} = useTranslation()
  const {fetchData} = HandleFetchData()
  const location = useLocation();
  const {showMessageComponent} = useShowMessageComponent()

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const divarIncomId = searchParams.get('state')

  // متغیر و useState های لوکال صفحه
  const [otp, setOTP] = React.useState()
  const [validationShow, setValidationShow] = React.useState({});
  const phone = searchParams.get('phone')

  // اضافه کردن Attribute به dom پروژه
  document.documentElement.setAttribute('lang', i18n.language);
  document.documentElement.setAttribute('dir', i18n.dir(i18n.language));


  React.useEffect(() => {
    otp?.length >= 6 && validation()
  }, [otp])

  // React.useEffect(() => {
  //   phone && getVerifyCode()
  // }, [phone])

  // اضافه کردن کد یکبار مصرف در متغیر لوکال
  const handleChangeOTP = (otp) => setOTP(otp);


  const validation = () => {
    !otp ? setValidationShow({
         otp: 'وارد کردن کد الزامی میباشد'
       }) :
       (!divarIncomId || divarIncomId == 'null') ? sendVerifyCode() : sendVerifyCodeDivar()
  }

  const getVerifyCode = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/sendActivationCode', {
         "mobileNo": phone,
       },
       "application/x-www-form-urlencoded", '', '', ''
    )
    if (fetch?.IsSuccess) {
      // navigate('/', {replace: true})
      showMessageComponent(fetch?.Message, 'success')
    } else if (fetch?.StatusCode == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      showMessageComponent(fetch?.Message, 'success')
    }
    dispatch(setLoading(false))
  }


  // ارسال کد یکبار مصرف و تایید حساب کاربری
  const sendVerifyCode = async () => {
    dispatch(setLoading(true))

    let fetch = await fetchData('', 'GET', '/verifyActivationCode', '',
       "application/x-www-form-urlencoded", {
         activatationCode: otp,
         userName: phone
       }, '', ''
    )
    if (fetch?.IsSuccess) {
      navigate('/auth/login', {replace: true})
      showMessageComponent(fetch?.Message || "عملیات با موفقیت انجام شد", 'success')

    } else if (fetch?.StatusCode == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      showMessageComponent(fetch?.response?.data?.message || 'مشکلی در درخواست شما به وجود امده است', 'error')
    }

    dispatch(setLoading(false))
  }

  // ارسال کد یکبار مصرف و تایید حساب کاربری
  const sendVerifyCodeDivar = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/verifyOtpLogin', {
         "Code": otp,
         "userName": phone,
         "divarIncomId": divarIncomId,
       },
       "application/x-www-form-urlencoded", '', '', ''
    )

    if (fetch && fetch?.success) {
      showMessageComponent(fetch?.message || 'ورود با موفقیت انجام شد', 'success')

      await localStorage.setItem('token', fetch?.data?.Token)
      localStorage.setItem('info-user', JSON.stringify({
        "FullName": (fetch?.data?.FirstName || fetch?.data?.LastName) ? fetch?.data?.FirstName + ' ' + fetch?.data?.LastName : null,
        "Email": fetch?.data?.Email,
        "Mobile": fetch?.data?.Username,
        "IsAgent": fetch?.data?.IsAgent,
        "hasShop": fetch?.data?.hasShop,
        "IsSelfCollector": fetch?.IsSelfCollector,
      }))
      location?.pathname !== '/auth/login' ? navigate({
        pathname: location?.pathname,
        search: createSearchParams({
          state: divarIncomId
        }).toString(),
        replace: true
      }) : navigate({
        pathname: "/singleOrder",
        search: createSearchParams({
          state: divarIncomId
        }).toString(),
        replace: true
      });
    } else if (fetch && !fetch?.success) {
      showMessageComponent(fetch?.message || 'ورود با مشکل مواجه شد', 'error')

    } else if (fetch?.status == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else if (fetch?.response?.data?.message) {
      showMessageComponent(fetch?.response?.data?.message, 'error')
    } else {
      showMessageComponent(fetch?.response?.data?.data?.ErrorList?.[0], 'error')
    }

    dispatch(setLoading(false))
  }


  return (
     <>
       <div className="authPage">
         <div className="container">
           <div className="row">
             <div className="col-12 col-lg-2 col-xl-3"/>
             <div className="col-12 col-lg-8 col-xl-6 ">
               <div className="body-page">

                 <div className="logo">
                   <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt="پستِکس" loading="lazy"/>
                 </div>
                 <h6 className="description">{t("forgetPassword.t1")}</h6>
                 <h6 className="title">{t("forgetPassword.t2")}</h6>

                 <div className="input-otp">
                   <OtpInput
                      id="otp"
                      value={otp}
                      onChange={handleChangeOTP}
                      numInputs={6}
                      isInputNum
                      renderInput={(props) => <input {...props} />}
                   />
                 </div>

                 {
                   validationShow?.otp &&
                   <p className="error">{validationShow?.otp}</p>
                 }

                 {/*دکمه ارسال کد یکبار مصرف*/}
                 <div className="_btnGroup_blue">
                   <button className="btnFill" onClick={() => validation()} id="validation">
                     {
                       selector?.loading?.isLoading ?
                          <Box sx={{display: 'flex'}}>
                            <CircularProgress size={20}/>
                          </Box>
                          :
                          <span>{t("forgetPassword.t3")}</span>
                     }
                   </button>
                 </div>

                 {/*دکمه رفتن به صفحه ورود*/}
                 <div className="route-link">
                   <p>{t("forgetPassword.t4")}</p>
                   <button onClick={() => getVerifyCode()} id="getVerifyCode">{t("forgetPassword.t7")}</button>
                 </div>

                 {/*دکمه برگشت به صفحه اصلی*/}
                 <Link to={{pathname: '/', search: location?.search}} className="goBack" id="home">
                   <p>{t("forgetPassword.t6")}</p>
                   <KeyboardBackspace/>
                 </Link>

               </div>
             </div>
             <div className="col-12 col-lg-2 col-xl-3"/>
           </div>
         </div>
       </div>
     </>
  )
}

